// extracted by mini-css-extract-plugin
export var phone = "_15-0";